export default __webpack_public_path__ + "assets/media/start.bd5bd3ad.jpg";